import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import HomeSubSaveWrap from '../../views/widget/home/sub/save/HomeSubSaveWrap';
import { widgetActions } from '../../store/modules/widget';

class SubPageCreateContainer extends Component {
  componentWillUnmount() {
    const { setData } = this.props;
    /**
     *  서브 페이지 데이터 초기화
     */
    setData({
      path: ['subPageSave'],
      value: {
        /**
         *  페이지 제목
         */
        title: null,
        /**
         *  메모
         */
        memo: null,
      },
    });
  }

  /**
   *  추천 상품 후기 복사하기
   */
  onSubmit = () => {
    const { form, subPageSave, insertSubPage } = this.props;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, async (err) => {
      if (err) return;

      insertSubPage({
        subPageInfo: {
          /**
           *  페이지 제목
           */
          title: subPageSave.title,
          /**
           *  메모
           */
          memo: subPageSave.memo,
        },
      });
    });
  };

  render() {
    const { form, subPageSave, setData } = this.props;

    return <HomeSubSaveWrap form={form} setData={setData} subPageSave={subPageSave} onSubmit={this.onSubmit} />;
  }
}

const mapStateToProps = (state) => {
  return {
    subPageSave: state.widget.subPageSave,
  };
};

const mapDispatchToProps = {
  setData: widgetActions.setData,
  insertSubPage: widgetActions.insertSubPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(SubPageCreateContainer));
